<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col cols="12">
          <parametros ref="parametrosREF" :item="item" :title="title" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-racionalizacao-com"
            color="green"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvar"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import RacionalizacaoComService from '@/services/RacionalizacaoComService';

  export default {
    name: 'RacionalizacaoComEdit',
    components: {
      Parametros: () => import('@/components/racionalizacaoCom/Parametros.vue')
    },
    data: () => ({
      item: {},
      loading: false
    }),
    computed: {
      title() {
        return this.$route.params.id ? 'Editar Racionalização do COM' : 'Nova Racionalização do COM';
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.getById(this.$route.params.id);
      }
    },
    methods: {
      getById(id) {
        this.loading = true;
        RacionalizacaoComService.getById(id)
          .then((res) => {
            this.item = res.data.data || {};
          })
          .catch(() => this.$toast.error('Erro ao carregar execução.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      },
      salvar() {
        const postData = this.$refs.parametrosREF.exportData();
        const id = this.$route.params.id || null;

        this.loading = true;
        RacionalizacaoComService.salvar(id, postData)
          .then(() => {
            this.$toast.success('Racionalização do COM salva com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Racionalização do COM Histórico' });
          })
          .catch(() => this.$toast.error('Erro ao salvar Racionalização do COM.', '', { position: 'topRight' }))
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
